import type { SkillSummary } from './types';

type SkillReadErrorKind = 'access' | 'unavailable' | 'load';
const messages: Record<SkillReadErrorKind, string> = {
  access:
    'Não foi possível acessar esta skill. Verifique sua sessão e permissão.',
  unavailable: 'Esta skill não está disponível.',
  load: 'Não foi possível carregar o conteúdo. Tente novamente.',
};

export class SkillReadError extends Error {
  constructor(readonly kind: SkillReadErrorKind) {
    super(messages[kind]);
    this.name = 'SkillReadError';
  }
}

export async function readSkillResponse(
  response: Response,
  id: string,
): Promise<SkillSummary> {
  if (response.status === 401 || response.status === 403) {
    throw new SkillReadError('access');
  }
  if (response.status === 404) throw new SkillReadError('unavailable');
  if (!response.ok) throw new SkillReadError('load');
  const value = await response.json();
  if (value === null) throw new SkillReadError('unavailable');
  if (typeof value !== 'object' || Array.isArray(value)) {
    throw new SkillReadError('load');
  }
  if (value.id !== id) throw new SkillReadError('unavailable');
  if (
    typeof value.name !== 'string' ||
    !value.name.trim() ||
    (value.content !== null &&
      value.content !== undefined &&
      typeof value.content !== 'string')
  ) {
    throw new SkillReadError('load');
  }
  return {
    ...value,
    content: value.content ?? '',
    version: typeof value.version === 'string' ? value.version : null,
    status: typeof value.status === 'string' ? value.status : '',
  };
}
